import { Tag, TagColor } from '@shinetools/lumen-react'
import type { ReactElement } from 'react'

import { BillStatus } from '@features/bills/enums/billStatus'

import { BillsTableRow } from '../../types/billsTableRow'

type StatusConfig = {
  color: TagColor
  labelKey: string
}
/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
const statusToConfigMapping: Record<Exclude<BillStatus, BillStatus.All>, StatusConfig> = {
  [BillStatus.Paid]: {
    color: 'success',
    labelKey: 'Paid',
  },
  [BillStatus.Draft]: {
    color: 'blue',
    labelKey: 'To review',
  },
  [BillStatus.Overdue]: {
    color: 'danger',
    labelKey: 'Overdue',
  },
  [BillStatus.PartiallyPaid]: {
    color: 'warning',
    labelKey: 'Partially Paid',
  },
  [BillStatus.Unpaid]: {
    color: 'warning',
    labelKey: 'Unpaid',
  },
  [BillStatus.Voided]: {
    color: 'neutral',
    labelKey: 'Voided',
  },
}

interface BillsTableBillStatusCellProps {
  row: BillsTableRow
}

export const BillsTableBillStatusCell = ({ row }: BillsTableBillStatusCellProps): ReactElement | null => {
  if (!row.derivedStatus) {
    return null
  }

  const config = statusToConfigMapping[row.derivedStatus]

  // Run-time safety check for unknown statuses
  if (!config) {
    return null
  }

  return <Tag color={config.color} type="subtle" label={config.labelKey} />
}
